angular
  .module('contributor')

  .directive('selectCertification', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        certification: '='
      },
      template:
        '<select ng-model="certification" ng-options="c.value for c in certifications track by c._id">' +
        '<option value="">-</option>' +
        '</select>',
      controller: [
        '$scope',
        '$controller',
        'CertificationCrud',
        function($scope, $controller, CertificationCrud) {
          $controller('ListCtrl', {
            $scope: $scope,
            crud: new CertificationCrud('-list'),
            packageName: 'certifications',
            dataName: 'certifications',
            filters: {}
          });

          $scope.loadList();
        }
      ]
    };
  });
